import { StockStatusEnum } from '@petsmart-ui/sparky';

import { validateStockStatus } from '../../../utils/stockStatusUtils';

export const SELECT_STORE_STATUS_TEXT = 'Select a store to check availability';

export const SHIPPING_RESTRICTION_TEXT =
    'This item does not ship to a PO box and may exceed the standard delivery window.';

export type InventoryStatusTone = 'success' | 'error';

export type DeliveryInventoryMethod = 'bopis' | 'sth';

export type DeliveryInventoryStatus = Readonly<{
    isLoading: boolean;
    label: string;
    tone?: InventoryStatusTone;
}>;

type DeliveryInventoryStatusInput = Readonly<{
    method: DeliveryInventoryMethod;
    isLoading: boolean;
    hasStore?: boolean;
    availableStock?: number | null;
    minimumCaseQty: number;
    customPharmacyOOS?: boolean;
}>;

export function getInventoryStatusLabel(stockStatus: StockStatusEnum): string {
    if (stockStatus === StockStatusEnum.InStock) return 'In stock';
    if (stockStatus === StockStatusEnum.FewLeftInStock) return 'Only a few left';

    return 'Out of stock';
}

export function getInventoryStatusTone(stockStatus: StockStatusEnum): InventoryStatusTone {
    return stockStatus === StockStatusEnum.InStock ? 'success' : 'error';
}

export function getShippingRestrictionText(poBoxRestricted?: boolean): string | null {
    return poBoxRestricted ? SHIPPING_RESTRICTION_TEXT : null;
}

export function getDeliveryInventoryStatus({
    method,
    isLoading,
    hasStore = false,
    availableStock,
    minimumCaseQty,
    customPharmacyOOS = false,
}: DeliveryInventoryStatusInput): DeliveryInventoryStatus {
    if (isLoading) {
        return { isLoading: true, label: '' };
    }

    if (method === 'bopis' && !hasStore) {
        return { isLoading: false, label: SELECT_STORE_STATUS_TEXT };
    }

    const stockStatus = validateStockStatus({
        stockQuantity: availableStock ?? 0,
        minimumCaseQty,
        ...(method === 'sth' ? { customPharmacyOOS } : {}),
    });

    return {
        isLoading: false,
        label: getInventoryStatusLabel(stockStatus),
        tone: getInventoryStatusTone(stockStatus),
    };
}
